exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-error-holder{color:#373737}.sc-page-mode-doing .app-error-holder{margin:20px;margin-right:60px}.sc-page-mode-manage .app-error-holder{margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/common/AppErrorNotification/index.scss
// module id = 1008
// module chunks = 0